import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'langchain-embeddings',
  version: '1.0.0',
  properties: [
    {
      key: 'provider',
      label: 'Provider',
      type: 'options',
      required: true,
      default: 'openai',
      options: [
        { value: 'openai', name: 'OpenAI' },
        { value: 'cohere', name: 'Cohere' },
        { value: 'huggingface', name: 'HuggingFace' },
      ],
    },
    {
      key: 'credentialId',
      label: 'API Credential',
      type: 'string',
      required: true,
      typeOptions: {
        credentialType: '={{$parameter["provider"]}}',
      },
    },
    {
      key: 'model',
      label: 'Model',
      type: 'string',
      default: 'text-embedding-ada-002',
      displayOptions: {
        show: {
          provider: ['openai'],
        },
      },
    },
    {
      key: 'inputText',
      label: 'Input Text',
      type: 'string',
      required: true,
      typeOptions: {
        rows: 4,
      },
      placeholder: 'Text to embed...',
    },
  ],
};

export default schema;
